import React, {useState} from 'react';
import {Box, Grid, Typography} from "@mui/material";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Top from "../Top";
import Bottom from "../Bottom";
import ScatterChart from "../../components/ScatterChart";
import DeviceNormalRange from "../../components/DeviceNormalRange";
import {BloodLegend} from "./HistoryDeviceBloodDetail";
import {
  BLOOD_TIME_SLOTS,
  DeviceInfo,
} from "../../utils/deviceInfo";
import { bloodTrendOf, useHealthDevice } from "../../utils/healthDeviceApi";

const HistoryDeviceBloodMonthHistory = (props: { device: DeviceInfo }) => {
  const device = props.device;
  const [monthValue, setMonthValue] = useState(new Date().getMonth() + 1);

  // 이번 달 일수만큼 시간대별 혈당 추이를 만든다
  const dayCount = new Date(new Date().getFullYear(), monthValue, 0).getDate();
  const { data: deviceData } = useHealthDevice(0);
  const bloodTrend = bloodTrendOf(deviceData, dayCount, 0);

  const monthSeries = BLOOD_TIME_SLOTS.map((slot) => ({
    label: slot.label,
    data: bloodTrend[slot.key].map((value, index) => ({ x: index + 1, y: value, id: slot.key + index })),
  }));

  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title={'월간 ' + device.typeName + ' 기록'} />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%' }}>
        <Box>

          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setMonthValue((prev) => prev - 1)} sx={{ 'display': monthValue > 1 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
            {new Date().getFullYear() + '년 ' + monthValue + '월'}
            <ArrowRightIcon onClick={() => setMonthValue((prev) => prev + 1)} sx={{ 'display': monthValue < new Date().getMonth() + 1 && monthValue > 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          <Box sx={{ mt: 4, bgcolor: '#fff', p: '10px 10px 20px 10px', borderRadius: '15px', boxShadow: CardShadow }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack>
                <Typography component="div" sx={{ fontSize: 16, color: '#555', fontWeight: 700 }}>월간현황</Typography>
              </Stack>
            </Stack>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <Typography component="div" sx={{ fontSize: 14, color: '#333', fontWeight: 700 }}>{device.name}</Typography>
              <Typography component="div" sx={{ fontSize: 12, color: '#555', mr: .5 }}>이번 달의
                <Typography component="span" sx={{ fontSize: 14, color: '#0069ce', fontWeight: 700, mb: 2 }}> 혈당 </Typography>
                기록이에요.
              </Typography>
            </Box>
            <Divider />

            <Box sx={{ mt: -3.5, '& .MuiChartsAxis-tickContainer:last-child': { display: 'none' } }}>
              <ScatterChart series={monthSeries} colors={BLOOD_TIME_SLOTS.map((slot) => slot.color)} />
              <BloodLegend />
            </Box>
          </Box>

          <DeviceNormalRange deviceType={device.type} />
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

const CardShadow = '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)';

export default HistoryDeviceBloodMonthHistory;
